<template>
    <div class="flex">
        <Navigation class="flex-none"/>
        <div class="appContainer container">
            <div v-if="!isHomepage" class="b-corp">
                <img alt="Logo B-Corp" src="/images/b-corp.png"/>
            </div>
            <router-view/>
        </div>
    </div>
</template>

<script>
import Navigation from "@/components/NavBar/Navigation";
import {apiCallRebuild} from "@/helper";
import {API_ROUTES} from "@/Services/api.common.service";

export default {
    mounted() {
        if (this.$store.state.account.role === "ROLE_ADMIN") {
            this.$router.push("/admin");
        } else {
            this.moodCheck();
        }
    },
    components: {
        Navigation,
    },
    methods: {
        async moodCheck() {
            const {mood} = await apiCallRebuild(API_ROUTES.mood);

            if (!mood?.ask) {
                await this.$router.push({name: "lemon"});
            }
        },
    },
    computed: {
        isHomepage() {
            return this.$route.name === 'home';
        }
    }
};
</script>

<style lang="scss">
.appContainer {
    height: 100%;
    margin: 0 auto auto;
    @apply pt-12 pb-12 pl-12;
    overflow: hidden;
    padding-right: 40px;
    width: 100%;
    max-width: 1280px;
    position: relative;
}

.b-corp {
    position: absolute;
    right: 40px;
    top: 3rem;
    width: 55px;
    z-index: 10;
}
</style>
